<template>
    <div class="users-style">
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance / Approver Settings</span>
        </h4>

        <div class="row mt-4">
            <div class="col-md-6 px-4">
                <div class="ibox px-3 py-2">
                  <div class="ibox-title dashboard_title px-0">
                      <h4>Leave Approver Settings</h4>
                  </div>
                  <div class="ibox-content px-0 pt-4">
                      <b-overlay :show="showoverlay" rounded="sm">
                          <b-form @submit.stop.prevent>
                              <div class="row">
                                  <div class="col-sm-12">
                                      <b-form-checkbox v-model="fdata.status" name="check-button-leave" class="pt-2" :value="1" :unchecked-value="0" switch>
                                          Enable Leave Approver
                                      </b-form-checkbox>
                                  </div>
                                  <div class="col-sm-6 mt-3">
                                      <b-form-group id="leave_approver_type-group" label="Leave Approval Process" class="required-field" label-for="leave_approver_type">
                                          <b-form-select id="leave_approver_type" name="leave_approver_type" v-model="fdata.approver_type" :options="approver_types"></b-form-select>
                                      </b-form-group>
                                  </div>
                              </div>
                              <div class="btn-wrapper">
                                  <b-button class="btn-primary" variant="primary" @click="setSettings">Submit</b-button>
                              </div>
                          </b-form>
                      </b-overlay>
                  </div>
                </div>
            </div>
            <div class="col-md-6 px-4" v-if="company_access_settings['regularization']">
                <div class="ibox px-3 py-2">
                  <div class="ibox-title dashboard_title px-0">
                      <h4>Attendance Adjustment Approver Settings</h4>
                  </div>
                  <div class="ibox-content px-0 pt-4">
                      <b-overlay :show="showoverlay" rounded="sm">
                          <b-form @submit.stop.prevent>
                              <div class="row">
                                  <div class="col-sm-12">
                                      <b-form-checkbox v-model="fdata1.status" name="check-button-adjustment" class="pt-2" :value="1" :unchecked-value="0" switch>
                                          Enable Attendance Adjustment Approver
                                      </b-form-checkbox>
                                  </div>
                                  <div class="col-sm-6 mt-3">
                                      <b-form-group id="adjustment_approver_type-group" label="Approval Process" class="required-field" label-for="adjustment_approver_type">
                                          <b-form-select id="adjustment_approver_type" name="adjustment_approver_type" v-model="fdata1.approver_type" :options="approver_types"></b-form-select>
                                      </b-form-group>
                                  </div>
                              </div>
                              <div class="btn-wrapper">
                                  <b-button class="btn-primary" variant="primary" @click="setSettings1">Submit</b-button>
                              </div>
                          </b-form>
                      </b-overlay>
                  </div>
                </div>
            </div>
          <div class="col-md-6 px-4" v-if="company_access_settings['mobility']">
            <div class="ibox px-3 py-2">
              <div class="ibox-title dashboard_title px-0">
                <h4>Attendance Mobility Approver</h4>
              </div>
              <div class="ibox-content px-0 pt-4">
                <b-form-group id="attendance_mobility_approver-group" label-for="attendance_mobility_approver">
                  <b-form-checkbox switch id="attendance_mobility_approver" v-model="attendance_mobility_approver" name="attendance_mobility_approver" :value="1" :unchecked-value="0">
                    Enable Attendance Mobility Approver
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group id="attendance_mobility_hierarchy-group" label-for="attendance_mobility_hierarchy">
                  <b-form-checkbox switch id="attendance_mobility_hierarchy" v-model="attendance_mobility_hierarchy" name="attendance_mobility_hierarchy" :value="1" :unchecked-value="0">
                    Enable Attendance Hierarchy
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group id="attendance_approver_type-group" label="Attendance Approval Process" class="required-field mt-2 w-50" label-for="attendance_approver_type">
                  <b-form-select id="attendance_approver_type" name="attendance_approver_type" v-model="attendance_approver_type" :options="approver_types" ></b-form-select>
                </b-form-group>
              </div>
              <div class="btn-wrapper pb-4">
                <b-button @click="changeMobilityStatus">Submit</b-button>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return {
      showoverlay: false,
      company_access_settings: {},

      approver_types:[{
        value: 'sequential',
        text: 'Sequential Approval',
      },{
        value: 'anyone',
        text: 'Any-one Approval',
      },],

      fdata: {
        status: 0,
        approver_type: 'sequential',
      },
      fdata1: {
        status: 0,
        approver_type: 'sequential',
      },

      attendance_mobility_approver: 0,
      attendance_mobility_hierarchy: 0,
      attendance_approver_type: 'sequential',
    }
  },
  methods:{
    getSettings(){
      axios.get(this.$api_url + '/leave-attendance/approver/settings/1').then(response => {
        this.fdata = response.data;
      }).catch(error => { this.serverError(error); });
    },
    getSettings1(){
      axios.get(this.$api_url + '/leave-attendance/approver/settings/3').then(response => {
        this.fdata1 = response.data;
      }).catch(error => { this.serverError(error); });
    },
    setSettings(){
      let formData = new FormData();
      for(let [k,v] of Object.entries(this.fdata)) {
        formData.append(k, v);
      }
      axios.post(this.$api_url + '/leave-attendance/approver/settings/1', formData).then(response => {
        this.$bvToast.toast('Settings saved successfully',{
          solid: true,
          title: 'Saved',
          variant: 'success',
        })
      }).catch(error => { this.serverError(error); });
    },
    setSettings1(){
      let formData = new FormData();
      for(let [k,v] of Object.entries(this.fdata1)) {
        formData.append(k, v);
      }
      axios.post(this.$api_url + '/leave-attendance/approver/settings/3', formData).then(response => {
        this.$bvToast.toast('Settings saved successfully',{
          solid: true,
          title: 'Saved',
          variant: 'success',
        })
      }).catch(error => { this.serverError(error); });
    },

    getAttendanceMobilityStatus(){
      axios.get(this.$api_url + '/leave-attendance/approver/settings/2').then(response => {
        this.attendance_mobility_approver = response.data.status;
        this.attendance_approver_type = response.data.approver_type;
        this.attendance_mobility_hierarchy = response.data.hierarchy;
      }).catch(error => { this.serverError(error); });
    },

    changeMobilityStatus(){
      let formData = new FormData();
      formData.append('approver', this.attendance_mobility_approver);
      formData.append('hierarchy', this.attendance_mobility_hierarchy);
      formData.append('approver_type', this.attendance_approver_type);

      axios.post(this.$api_url + '/leave-attendance/attendance-mobility/status', formData).then(response => {
        this.getAttendanceMobilityStatus();
        this.$bvToast.toast(response.data.message,{
          variant: 'success',
          title: 'Success',
          solid: true,
        });
      }).catch(error => { this.serverError(error); });
    },

    get_access_settings() {
        if (!this.checkNet()) return false;

        axios.get(this.$api_url + '/leave-attendance/module/settings')
            .then(response => {
                this.company_access_settings = response.data.reduce((result, item) => {
                    result[item.module_key] = Number(item.value) === 1;
                    return result;
                }, {});
            })
            .catch(error => {
                this.serverError ? this.serverError(error) : console.log(error);
            });
    },
  },
  created(){
    this.getSettings();
    this.getSettings1();
    this.getAttendanceMobilityStatus();
    this.get_access_settings();
  }
}
</script>